var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-date-picker", {
        attrs: {
          type: "datetimerange",
          "range-separator": "~",
          "default-time": ["00:00:00", "23:59:59"],
          "start-placeholder": "开始日期",
          "end-placeholder": "结束日期",
          format: _vm.dateFormat,
        },
        on: { input: _vm.handleChange },
        model: {
          value: _vm.convertedVal,
          callback: function ($$v) {
            _vm.convertedVal = $$v
          },
          expression: "convertedVal",
        },
      }),
      _vm._v(" "),
      _c("span", { staticClass: "days" }, [
        _vm._v(_vm._s(_vm.unitStr) + "数：" + _vm._s(_vm.value.days || "无")),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }